import { useQuery } from '@tanstack/react-query';

import { useComplianceApi } from '../api';
import { compKeys } from '../query-key-factory';
import { ComplianceCause } from '../types';
import { ComplianceCauseResponse } from './complianceCause.types';

const useShowComplianceCause = <T = ComplianceCause>({
  uuid,
  select,
}: {
  uuid?: string | null;
  select?: (data?: ComplianceCause) => T;
}) => {
  const ComplianceApi = useComplianceApi();
  const getCause = async () => {
    const { data } = await ComplianceApi.get<ComplianceCauseResponse>(`/causes/${uuid}`);
    return data.cause;
  };

  const key = uuid ? compKeys.id(uuid).causes.id(uuid).detail : [];

  return useQuery({
    queryKey: key,
    queryFn: getCause,
    enabled: !!uuid,
    staleTime: 120000,
    select,
  });
};

export { useShowComplianceCause };
